/*globals google*/
(function () {
	'use strict';

	angular
		.module('invesfleet')
		.controller('InformeItinerariosPuntosPasoController', InformeItinerariosPuntosPasoController);

	InformeItinerariosPuntosPasoController.$inject = [
		'$stateParams', 'genericDataService', '$rootScope', '$state',
		'$filter', '$q', '$scope'];

	/* jshint maxstatements:false */
	/* jshint maxparams:false */
	function InformeItinerariosPuntosPasoController($stateParams, genericDataService, $rootScope, $state, $filter,
		$q, $scope) {

		/* PUBLIC VARIABLES */
		var vm = this;
		vm.init = init;
		vm.data = {
			fechaIni: '',
			fechaFin: ''
		};
		//vm.tipo;
		vm.genericData = {
			comboVehicle: {
				list: null,
				selected: {
					id: null
				}
			},
			comboGrupos: {
				list: null,
				selected: {
					id: null
				}
			}
		};
		(function () {
			vm.tipo = 'vehiculo';
			loadData();
		})();

		function loadData() {
			getGenericData();
		}

		function init(parentVm) {
			parentVm.getData = getData;
		}

		function getGenericData() {
			genericDataService.getFlota().then(function (result) {
				vm.genericData.comboVehicle.list = result;
				vm.genericData.comboVehicle.selected = vm.genericData.comboVehicle.list[0];
			});
			genericDataService.getGrupos().then(function (result) {
				vm.genericData.comboGrupos.list = result;
				vm.genericData.comboGrupos.selected = vm.genericData.comboGrupos.list[0];
			});
		}

		function getData() {
			var data = {};
			data.url = '/INVESFLEET/rpt_velocity';
			data.datosPeticion = [{ field: 'fechaInicio', value: vm.data.fechaIni },
			{ field: 'fechaFin', value: vm.data.fechaFin },
			{ field: 'flotaId', value: vm.genericData.comboVehicle.selected.id }
			];
			return data;
		}

	}
})();